import api from '@/api/api'
import router from '@/router/index'
// import { schema } from 'normalizr'

export default {
  namespaced: true,
  state: {
    list: {},
    valoraciones: []
  },
  mutations: {
    setValoraciones (state, payload) {
      state.valoraciones = payload
    },
  },
  actions: {
    getIncidencias ({ rootState }, values) {
      let rolProveedorEstados = false
      let rolProveedor = rootState.login.roles.find(x => x === "PV_PROVEEDOR") !== undefined

      if(rootState.login.rolProveedor){
        if(rootState.login.idubapi.PERMISOS_ROL_PROVEEDOR_WEB.GESTION_ESTADOS === "1" || rootState.login.idubapi.PERMISOS_ROL_PROVEEDOR_WEB.GESTION_ESTADOS === 1){
          rolProveedorEstados = true
        }
      }
      
      return new Promise((resolve, reject) => {
        api.post('/informes/getIncidencias', {
          credentials: rootState.login.credentials,
          values: Object.assign({}, values, {tiposSolicitudesDisponibles: rootState.login.idubapi.tiposSolicitudes, tiposDeVisita: rootState.login.idubapi.PERMISOS_ACTOR_VISITAS_PV || null, rolProveedor: rolProveedor, rolProveedorEstados: rolProveedorEstados})
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response.data)
          }
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    getEstadisticasIncidencias ({ rootState }, values) {
      return new Promise((resolve, reject) => {
        api.post('/informes/getEstadisticasIncidencias', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response.data)
          }
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    getDocumentos ({ rootState }, values) {
      let rolProveedorEstados = false
      let rolProveedor = rootState.login.roles.find(x => x === "PV_PROVEEDOR") !== undefined
      
      if(rootState.login.rolProveedor){
        if(rootState.login.idubapi.PERMISOS_ROL_PROVEEDOR_WEB.GESTION_ESTADOS === "1" || rootState.login.idubapi.PERMISOS_ROL_PROVEEDOR_WEB.GESTION_ESTADOS === 1){
          rolProveedorEstados = true
        }
      }

      return new Promise((resolve, reject) => {
        api.post('/informes/obtenerInformeSoporteDocumental', {
          credentials: rootState.login.credentials,
          values: Object.assign({}, values, {tiposSolicitudesDisponibles: rootState.login.idubapi.tiposSolicitudes, tiposDeVisita: rootState.login.idubapi.PERMISOS_ACTOR_VISITAS_PV || null, rolProveedor: rolProveedor, rolProveedorEstados: rolProveedorEstados})
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response.data)
          } else {
            reject(response)
          }
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    getEncuestas ({ rootState }, values) {
      return new Promise((resolve, reject) => {
        api.post('/informes/getEncuestas', {
          credentials: rootState.login.credentials,
          values: Object.assign({}, values, {tiposSolicitudesDisponibles: rootState.login.idubapi.tiposSolicitudes})
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response.data)
          }
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    obtenerValoraciones ({ rootState, commit }) {
      return new Promise((resolve, reject) => {
        api.post('/informes/obtenerValoraciones', {
          credentials: rootState.login.credentials
        }).then(response => {
          if (response.data.result === 'OK') {
            commit('setValoraciones', response.data.data)
            resolve(true)
          }
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    getInteracionesIncidencias({ rootState,dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('/informes/getInteracionesIncidencias', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            reject(response.data)
            return
          }
          if (response.data.result === 'OK') {
            resolve(response.data)
          }
        })
          .catch(e => {
            reject(e)
          })
      })
    }
  },
  getters: {
    getValoraciones (state) {
      return state.valoraciones
    },
  }
}
